/* eslint-disable no-unused-vars */
import myPage from '../../../apis/myPage' 

import {
  SET_FROM_LIST_ORDER 
} from './mutations'

export const FROM_LIST_ORDER = 'FROM_LIST_ORDER'
export const GET_ORDER_LIST_HISTORY = 'GET_ORDER_LIST_HISTORY'
export const GET_FAVORITE_LIST = 'GET_FAVORITE_LIST'
export const GET_ORDERS_HISTORY = 'GET_ORDERS_HISTORY'
export const DELETE_FAVORITE = 'DELETE_FAVORITE'
export const SAVE_FAVORITE = 'SAVE_FAVORITE'
export const GET_STATUS_FAVORITE = 'GET_STATUS_FAVORITE'
export const GET_VIEWED_LIST_HISTORY = 'GET_VIEWED_LIST_HISTORY'
export const REMOVE_ITEM_IN_LIST = 'REMOVE_ITEM_IN_LIST'
export const GET_POINT_HISTORY = 'GET_POINT_HISTORY'


export default {
  [FROM_LIST_ORDER]({ commit }, fromListOrder) {
    commit(SET_FROM_LIST_ORDER, fromListOrder)
  },
  [GET_ORDER_LIST_HISTORY]({ commit }, data) {
    return myPage.getOrderListHistory(data.menuNm, data.startIndex, data.count, data.reserveSts)
  },
  [GET_ORDERS_HISTORY]({ commit }, params) {
    return myPage.getOrdersHistory(
      params.menuNm,
      params.startIndex,
      params.count,
      params.reserveSts
    )
  },
  [GET_POINT_HISTORY] ({commit}, params) {
    return myPage.getPointHistory(
      params.pointFrom,
      params.pointTo,
      params.startIndex,
      params.count,
      params.commandType
    )
  },
  [GET_FAVORITE_LIST]({ commit }, params) {
    return myPage.getFavoriteList(
      params.itemType,
      params.page,
      params.size,
      params.sort
    )
  },
  [DELETE_FAVORITE]({ commit }, menuNo) {
    return myPage.deleteFavorite(menuNo)
  },
  [SAVE_FAVORITE]({ commit }, data) {
    return myPage.addFavorite(data)
  },
  [GET_STATUS_FAVORITE]({ commit }, params) {
    return myPage.getStatusFavorite(params.menuNo, params.serviceType)
  },
  [GET_VIEWED_LIST_HISTORY]({ commit }, data) {
    return myPage.getViewedListHistory(data.itemType, data.page, data.size, data.sort)
  },
  [REMOVE_ITEM_IN_LIST]({ commit }, id) {
    return myPage.removeItemInList(id)
  }
}
